import * as React from 'react';
import { observer } from 'mobx-react-lite';

const styles = require('./EmptyState.scss');
const classNames = require('classnames/bind').bind(styles);

export interface EmptyStateProps {
    icon: string;
    mainMessage: string;
    detailMessage?: string;
    classNames?: {
        container?: string;
        mainMessage?: string;
    };
}

const EmptyState = observer(function EmptyState(props: EmptyStateProps) {
    const { icon, mainMessage, detailMessage } = props;

    const {
        container: containerClassName,
        mainMessage: mainMessageClassName,
    } = props.classNames || { container: null, mainMessage: null };

    return (
        <div className={classNames(styles.emptyStateContainer, containerClassName)}>
            {icon && <img className={styles.icon} src={icon} alt="" />}
            {mainMessage && (
                <span className={classNames(styles.mainMessageText, mainMessageClassName)}>
                    {mainMessage}
                </span>
            )}
            {detailMessage && <span className={styles.detailsMessageText}>{detailMessage}</span>}
        </div>
    );
});
export default EmptyState;
